export const crudForm = {
  CREATE_HEARING: "CreateHearing",
  TESTE_FORM: "testeForm",
  FORM_ONE_LABEL: "FormOneLabel",
};
